module.exports = __webpack_public_path__ + "static/media/FES_background.860c7d7a.jpg";